export default class Despesa {
	constructor(
		nome='',
		descricao='',
		data='',
		quantidade='',
		unidade_medida_id='',
		categoria_id='',
		valor=''
	){
		this.nome = nome;
		this.descricao = descricao;
		this.quantidade = quantidade;
		this.unidade_medida_id = unidade_medida_id;
		this.categoria_id = categoria_id;
		this.valor = valor;

        // Settando a data atual
		if(data){
			this.data = data;
		} else {
			var d = new Date();

			// Dia atual
			var day = d.getDate();
			if(day < 10){
				day = "0"+day
			}

			// Mês atual
			var month = d.getMonth() + 1;
			if(month < 10){
				month = "0"+month
			}

			this.data = d.getFullYear()+'-'+month+'-'+day;
		}
	}
}
